import { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { memberApi } from '@formosa/shared/api/member';
import { formatDateTime } from '@formosa/shared/utils/formatDateTime';
import { resolveMemberMediaUrl } from '@formosa/shared/utils/mediaUrl';
import { resolveNewsApiLang } from '@formosa/shared/utils/newsLang';
import { useTranslation } from '../../i18n/LocaleContext';

export default function AnnouncementDetailPage() {
  const { id } = useParams();
  const navigate = useNavigate();
  const { locale, t } = useTranslation();
  const [detail, setDetail] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  useEffect(() => {
    if (!id) {
      return undefined;
    }
    let cancelled = false;

    async function load() {
      setLoading(true);
      setError('');
      try {
        const data = await memberApi.announcementCenterDetail(id, { lang: resolveNewsApiLang(locale) });
        if (!cancelled) {
          setDetail(data);
        }
      } catch (err) {
        if (!cancelled) {
          setError(err.message || t('messages.loadFailed'));
          setDetail(null);
        }
      } finally {
        if (!cancelled) {
          setLoading(false);
        }
      }
    }

    load();
    return () => {
      cancelled = true;
    };
  }, [id, locale, t]);

  return (
    <div className="announcement-detail-page">
      <header className="announcement-detail-page__header">
        <button
          type="button"
          className="announcement-detail-page__back"
          aria-label={t('common.back')}
          onClick={() => navigate(-1)}
        >
          ‹
        </button>
      </header>

      <div className="announcement-detail-page__body">
        {loading ? <p className="messages-page__status">{t('common.loading')}</p> : null}
        {error ? <p className="messages-page__status messages-page__status--error">{error}</p> : null}
        {!loading && !error && detail ? (
          <article className="announcement-detail">
            <h1 className="announcement-detail__title">{detail.title}</h1>
            <p className="announcement-detail__time">{formatDateTime(detail.createTime)}</p>
            {detail.imgUrl ? (
              <img src={resolveMemberMediaUrl(detail.imgUrl)} alt="" className="announcement-detail__image" />
            ) : null}
            {detail.filmUrl ? (
              <div className="announcement-detail__video">
                <video src={resolveMemberMediaUrl(detail.filmUrl)} controls playsInline className="announcement-detail__video-player" />
              </div>
            ) : null}
            <div
              className="announcement-detail__content"
              dangerouslySetInnerHTML={{ __html: detail.body || '' }}
            />
          </article>
        ) : null}
      </div>
    </div>
  );
}
